import React from 'react';
import { useTimezone } from '../../contexts/TimezoneContext';
import styles from '../../styles/forms/TimezoneSettingsForm.module.scss';

const TimezoneSettingsForm: React.FC = () => {
  const { timezone, setTimezone, availableTimezones } = useTimezone();

  const handleTimezoneChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setTimezone(event.target.value);
  };

  const getCurrentTime = () => {
    try {
      return new Intl.DateTimeFormat('en-US', {
        timeZone: timezone,
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        timeZoneName: 'short'
      }).format(new Date());
    } catch (error) {
      return 'Invalid timezone';
    }
  };

  return (
    <div className={styles.timezoneSettingsForm}>
      <div className={styles.formGroup}>
        <label htmlFor="timezone-select" className={styles.label}>
          Timezone
        </label>
        <select
          id="timezone-select"
          value={timezone}
          onChange={handleTimezoneChange}
          className={styles.select}
        >
          {availableTimezones.map((tz) => (
            <option key={tz.value} value={tz.value}>
              {tz.label}
            </option>
          ))}
        </select>
      </div>
      
      <div className={styles.currentTimePreview}>
        <span className={styles.previewLabel}>Current time:</span>
        <span className={styles.previewTime}>{getCurrentTime()}</span>
      </div>
      
      <div className={styles.description}>
        <p>
          This timezone setting will be used to display all dates and times throughout the application. 
          Your selection is saved locally and will persist across sessions.
        </p>
      </div>
    </div>
  );
};

export default TimezoneSettingsForm;
